import { ServerSentEventService } from './server-sent-event.service';
import type { BookingJobEvent } from '@carvia/ros-client-types';

export const bookingJobEventsService = (bookingId: string) =>
  new ServerSentEventService<BookingJobEvent>(`/bookings/${bookingId}/job-events`);
